import React from 'react';
import QueryModes from '../../search/QueryModes';

const SORT_OPTIONS = [
  { id: 'created_at', label: 'created_at' },
  { id: 'updated_at', label: 'updated_at' },
  { id: 'volume', label: 'volume' },
  { id: 'start_date', label: 'start_date' },
  { id: 'end_date', label: 'end_date' },
  { id: 'null', label: 'None' },
];

const STRICT_FILTER_TYPE_OPTIONS = [
  { id: 'item_ids', label: 'Item Ids' },
  { id: 'ai_labels', label: 'AI Labels' },
  { id: 'tags', label: 'Tags' },
  { id: 'date', label: 'Date Range' },
  { id: 'boolean_filters', label: 'Boolean Filters' },
  { id: 'keywords', label: 'Keywords' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
];

const BOOST_FILTER_TYPE_OPTIONS = [
  { id: 'boost_wallet_labels', label: 'Wallet Labels' },
  { id: 'boost_wallet_tags', label: 'Wallet Tags' },
  { id: 'ai_labels', label: 'AI Labels' },
  { id: 'tags', label: 'Tags' },
  { id: 'date', label: 'Date Range' },
  { id: 'boolean_filters', label: 'Boolean Filters' },
  { id: 'keywords', label: 'Keywords' },
  { id: 'numeric_filters', label: 'Numeric Filters' },
];

const KalshiItemsQuery = () => {
  return (
    <QueryModes
      source="kalshi-items"
      sortOptions={SORT_OPTIONS}
      strictFilterTypeOptions={STRICT_FILTER_TYPE_OPTIONS}
      boostFilterTypeOptions={BOOST_FILTER_TYPE_OPTIONS}
    />
  );
};

export default KalshiItemsQuery;
